export const Bus = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M28 15V11" stroke="currentColor" stroke-width="2"/>
<path d="M4 15V11" stroke="currentColor" stroke-width="2"/>
<path d="M24 24H8C7.44772 24 7 23.5523 7 23V9C7 6.79086 8.79086 5 11 5H21C23.2091 5 25 6.79086 25 9V23C25 23.5523 24.5523 24 24 24Z" stroke="currentColor" stroke-width="2"/>
<path d="M7 9H25" stroke="currentColor" stroke-width="2"/>
<path d="M7 17H25" stroke="currentColor" stroke-width="2"/>
<path d="M23 28V24" stroke="currentColor" stroke-width="2"/>
<path d="M9 28V24" stroke="currentColor" stroke-width="2"/>
<rect x="10.5" y="20.5" width="1" height="1" fill="currentColor" stroke="currentColor"/>
<rect x="20.5" y="20.5" width="1" height="1" fill="currentColor" stroke="currentColor"/>
</svg>`;
